/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_TrailInputs */

const en_ui_sub_sport_trail = /** @type {(inputs: Ui_Sub_Sport_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trail`)
};

const de_ui_sub_sport_trail = /** @type {(inputs: Ui_Sub_Sport_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trail`)
};

/**
* | output |
* | --- |
* | "Trail" |
*
* @param {Ui_Sub_Sport_TrailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_trail = /** @type {((inputs?: Ui_Sub_Sport_TrailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_TrailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_trail(inputs)
	return de_ui_sub_sport_trail(inputs)
});